import React, { useEffect } from "react";
import Footer from "../../Footer/Footer";
import Header from "../../Header/Header";
import { Link } from "react-router-dom";

const Pricing = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const getDetails = () => {
    return (
      <section className="pt-8 pt-md-11 pb-8 pb-md-14">
        <div className="container">
          <div className="row align-items-center">
            <div className="col-12 col-md">
              <h2 className="display-6 mb-1">
                <span className="text-primary">Pricing</span>
              </h2>
            </div>
          </div>
          <div className="row">
            <div className="col-12 col-md-11">
              <div className="border rounded p-4 p-md-5 mb-6 mb-md-8">
                <h4 className="mb-3">Looking to switch to a new AA?</h4>
                <div className="d-flex flex-column flex-md-column align-items-md-start justify-content-between">
                  <p className="font-size-inherit text-gray-800 mb-3 mb-md-0 pr-md-4">
                    We want to be your preferred AA. Talk to us for bespoke
                    volume-based discounts on what you pay currently.
                  </p>
                  <Link to="/contactus" className="btn btn-primary mt-2 p-1 py-1" style={{fontSize: '1rem'}}>
                    Contact Us
                  </Link>
                </div>
              </div>

              <h4 className="mb-3">
                Our Services to Financial Information Users (FIUs)
              </h4>
              <p className="font-size-inherit text-gray-800 mb-6 mb-md-8">
                Our services include consent collection and management, data
                retrieval, and data sharing across a variety of use-cases and
                interfaces, including mobile, web, WhatsApp and Voice. All
                services include our highly responsive 16 x 7 support free of
                cost.
              </p>

              <h4 className="mb-5">
                Our services are priced based on the following models:
              </h4>

              <div className="row mb-6">
                <div className="col-12 mb-6">
                  <div
                    className="pl-4 h-100"
                    style={{ borderLeft: "3px solid #1b63f0" }}
                  >
                    <h5 className="mb-2 text-primary">Per Data Fetch</h5>
                    <p className="font-size-inherit text-gray-800 mb-0">
                      We charge for each instance of a data fetch from an
                      individual or business account. The exact fee varies
                      based on use-case, number of data points required, and
                      frequency. The rate per data fetch ranges from 20 paise
                      to Rs. 2.50.
                    </p>
                  </div>
                </div>

                <div className="col-12 mb-6">
                  <div
                    className="pl-4 h-100"
                    style={{ borderLeft: "3px solid #1b63f0" }}
                  >
                    <h5 className="mb-2 text-primary">
                      Per Active User Per Account
                    </h5>
                    <p className="font-size-inherit text-gray-800 mb-0">
                      We charge for each unique user x account combination
                      fetched during the billing period. The fee varies by
                      use-case, data points, type of financial information, and
                      frequency. The rate varies from Rs. 3 to Rs. 6.
                    </p>
                  </div>
                </div>

                <div className="col-12">
                  <div
                    className="pl-4 h-100"
                    style={{ borderLeft: "3px solid #1b63f0" }}
                  >
                    <h5 className="mb-2 text-primary">Volume-Based Pricing</h5>
                    <p className="font-size-inherit text-gray-800 mb-0">
                      FIUs requiring access to large volumes of aggregated
                      financial data (for multiple users or multiple data
                      retrievals) are eligible for volume-based pricing
                      discounts.
                    </p>
                  </div>
                </div>
              </div>

              <h4 className="mb-3">Notes</h4>
              <ol className="font-size-inherit text-gray-800 mb-6 pl-4">
                <li className="mb-2">
                  These rates are applicable for currently available FI types:
                  Current account, Savings accounts, Term deposits and
                  Recurring deposits, Mutual Funds, Equity Shares, NPS, etc.
                </li>
                <li className="mb-2">
                  Pricing for additional FI types, as and when enabled by
                  Financial Information Providers (FIPs), will be communicated
                  separately.
                </li>
                <li className="mb-2">
                  Pricing for additional FIP categories, as and when permitted
                  by RBI or other regulators, will be communicated separately.
                </li>
                <li className="mb-2">
                  The above pricing excludes charges (if any) levied by FIPs.
                  Charges levied by FIPs for supplying data to Finvu AA will be
                  charged to FIUs on actuals.
                </li>
              </ol>

              <p className="font-size-inherit text-gray-800 mb-0">
                Please email us at{" "}
                <a href="mailto:info@cookiejar.co.in">
                  info@cookiejar.co.in
                </a>{" "}
                or{" "}
                <Link className="ml-1" to="/contactus">
                  Contact Us
                </Link>{" "}
                for further information and discussion.
              </p>


            </div>
          </div>
        </div>
      </section>
    );
  };

  return (
    <>
      <Header></Header>
      {getDetails()}
      <Footer></Footer>
    </>
  );
};

export default Pricing;
